import * as React from 'react';

import useCarousel from './useCarousel';

export const CarouselContext = React.createContext(null);

export function CarouselProvider(props) {
  return 'carousel' in props ? (
    <UnloadedCarouselProvider {...props} />
  ) : (
    <LoadedCarouselProvider {...props} />
  );
}

function LoadedCarouselProvider({ children, ...props }) {
  const value = useCarousel(props);
  return (
    <CarouselContext.Provider value={value}>
      {children}
    </CarouselContext.Provider>
  );
}

function UnloadedCarouselProvider({ carousel, children }) {
  return (
    <CarouselContext.Provider value={carousel}>
      {children}
    </CarouselContext.Provider>
  );
}
